__turbopack_context__.v({
  "circle": "progressRing-module-scss-module__HW1YIG__circle",
  "firstRing": "progressRing-module-scss-module__HW1YIG__firstRing",
  "progressRingWrp": "progressRing-module-scss-module__HW1YIG__progressRingWrp",
  "secondRing": "progressRing-module-scss-module__HW1YIG__secondRing",
});
